import * as types from './mutation-types'

export const loadMethods = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/access/methods/collection', data).then((response) => {
            commit(types.LOAD_METHODS, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

